import { Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { formatDinero } from "../../../../../utils/formatDinero"
import { addItemsAction, addOfertaAction, obtenerDescuentosByPaqueteAction } from "../../../../../ducks/cotizadorPaqueteDuck"
import { catTipoItem } from "../../../../../constant/catTipoItem"
import { catTipoPago } from "../../../../../constant/catTipoPago"
const useConsultaDecuentos = () => {
    const { clavePaquete } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerDescuentosByPaqueteAction({ clavePaquete }))
    }, [dispatch, clavePaquete])
}
const FieldDescuento = () => {
    const { listaItems, listaDescuentos, cantidadPasajeros, paquete, metodoPago, oferta } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()
    useConsultaDecuentos()
    const handleChangeSelectValue = (event) => {
        const newDescuento = event.target.value
        const descuentoFind = listaDescuentos.find(descuentoItem => descuentoItem.IdPaqueteOferta === Number(newDescuento))
        if (!descuentoFind) return null
        
        const arraItems = listaItems.filter(item => {
            const tipoDescuento = descuentoFind.Operacion === "*" ? catTipoItem.DESCUENTO_PORCENTAJE : catTipoItem.DESCUENTO_MONTO;
            return item.price !== descuentoFind.Cantidad && item.type !== tipoDescuento;
        })

        let descuentoTipo = catTipoItem.DESCUENTO_MONTO
        if (descuentoFind.Operacion === "*") {
            descuentoTipo = catTipoItem.DESCUENTO_PORCENTAJE
        }
        let itemDescuento = {
            id: descuentoFind.IdPaqueteOferta,
            name: `${descuentoFind?.Descripcion}`,
            price: descuentoFind.Cantidad,
            currency: paquete.Moneda?.Clave,
            type: descuentoTipo,
            quantity: cantidadPasajeros,
            description: descuentoFind?.Descripcion
        }
        arraItems.push(itemDescuento)
        dispatch(addOfertaAction({ oferta: newDescuento }))
        dispatch(addItemsAction({ listaItem: arraItems }))
    }

    return <div style={{ margin: "2% 0" }}>
        <Grid container>
            <Grid item xs={12}>
                <FormControl variant="outlined" style={{ width: "98%" }}>
                    <InputLabel id="lDescuentos">Descuentos extraordinarios</InputLabel>
                    <Select
                        labelId="lDescuentos"
                        id="SDescuentos"
                        name="SDescuentosextraordinarios"
                        onChange={handleChangeSelectValue}
                        label="Descuentos extraordinarios"
                        value={oferta}
                        disabled={(listaDescuentos.length == 0 || Number(metodoPago) !== catTipoPago.PLAN_PAGOS)}
                    >
                        <MenuItem value="0" disabled>
                            {"Seleccione una opción"}
                        </MenuItem>
                        {listaDescuentos.map((descuento, index) => {
                            let descuentoPrecio = `${formatDinero(descuento.Cantidad)}`
                            if (descuento.Operacion === "*") {
                                descuentoPrecio = `${descuento.Cantidad}%`
                            }
                            return (
                                <MenuItem key={descuento.IdPaqueteOferta} value={`${descuento.IdPaqueteOferta}`}>
                                    {`${descuento?.Descripcion} (${descuentoPrecio})`}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    </div>
}
export default FieldDescuento